<template>
    <div class="e2e-gfx-board"  v-once>
          <!-- TODO: add hidden form equal to fragement-gfx-form? -->
         <div class="mc-gfx-board" :id="idOfDomTarget"/>
    </div>
</template>

<script>
import Vue from "vue";
import { newBoard } from "./gfx.js";
import createUuid from "uuid/v4";

export default {
  name: "fragment-gfx-board",
  props: ["fragment"],
  data() {
    return {
      idOfDomTarget: "gfxDomTarget_" + createUuid()
    };
  },
  mounted() {
    const that = this;
    Vue.nextTick(() => {
      newBoard(that.idOfDomTarget, that.fragment);
    });
  }
};
</script>
 

<style scoped>
.mc-gfx-board{
  width: 100%;
  height: 20%;
}
</style>